import { Injectable } from '@angular/core';
import { catchError, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { GetRoleListResponse, GetRoleResponse } from '../../interfaces/roles.interface';
import { getHeaders, handleError, handleResponse } from '../../shared/helpers/helpers';
import { DeleteResponse } from '../../shared/types/api-responses.type';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  private apiUrl = environment.api + '/roles';

  constructor(private http: HttpClient) { }

  getRoles(): Observable<GetRoleListResponse> {
    return this.http.get<GetRoleListResponse>(this.apiUrl).pipe(
      tap(response => handleResponse(response)),
      catchError(error => handleError(error))
    );
  }

  getRoleById(id: string): Observable<GetRoleResponse> {
    return this.http.get<GetRoleResponse>(`${this.apiUrl}/${id}`).pipe(
      tap(response => handleResponse(response)),
      catchError(error => handleError(error))
    );
  }

  deleteRoleById(id: string): Observable<DeleteResponse> {
    return this.http.delete<DeleteResponse>(`${this.apiUrl}/${id}`).pipe(
      tap(response => handleResponse(response)),
      catchError(error => handleError(error))
    );
  }
}
